import { RouterOutlet } from '@angular/router';

export abstract class IHaveRouterOutlet {
  routerOutlet: RouterOutlet;
}



// WEBPACK FOOTER //
// ./src/app/pillar/layout/history-outlet/IHaveRouterOutlet.ts